import { createFileRoute, Outlet } from '@tanstack/react-router';
import React from 'react';

export const Route = createFileRoute('/training')({
  component: TrainingLayout,
});

function TrainingLayout() {
  return <Outlet />;
}
